<template lang="pug">
  transition(name="modal")
    .modall-mask(@click="$emit('close')")
      .modall-wrapper
        .modall-container.device-details(@click.stop='')
          error-modal(v-if="showError" :lang="lang" @closeError="closeError" :errorSel="errorSel" :matrix="matrixSel")
          payment-modal(v-if="showPayment" :lang="lang" @closePayment="closePayment" :payment="payment")
          status-modal(v-if="showStatus" :lang="lang" @closeStatus="closeStatus" :statusSel="statusSel")
          button.close(type="button" aria-label="Close")
            span(aria-hidden="true" @click="$emit('close')" @keyup.esc="$emit('close')") &times;

          .panels

            .left-panel

              h2
                | {{device.name}} &nbsp;
                small
                  i.fas.fa-edit.fa-inverse.clickable(v-if="$store.getters.hasRole(['admin', 'manager'])" v-tooltip.top="lang['Decription']" @click="edit(lang['Decription'], device.description, 'description')")
                  | ({{device.description}})
              table.table.table-condensed.table-hover.device
                tbody
                  tr
                    th
                      i.fas.fa-id-card(v-tooltip.top="'UUID'")
                      | UUID
                    td {{device.uuid}}
                  tr(v-if="device.initialActivationAt")
                    th
                      i.fas.fa-calendar(v-tooltip.top="lang['Activation date']")
                      | {{lang['Activation date']}}
                    td {{device.initialActivationAt | formatDateTime}}
                  tr
                    th
                      i.fas.fa-calendar(v-tooltip.top="lang['Created date']")
                      | {{lang['Created date']}}
                    td {{device.createdAt | formatDateTime}}
                  tr
                    th
                      i.fas.fa-shield-alt.copy(v-tooltip.top="lang['Wave Agent ver.'] + '<br>' + lang['Copy teleport ID']" @dblclick="copyToClipboard(`kiosk-${device.localMAC.replace(/:/g, '')}`)")
                      | {{lang['Wave Agent ver.']}}
                    td {{device.version}}
                  tr
                    th
                      i.fas.fa-at.copy(v-tooltip.top="'IP'" @dblclick="copyToClipboard(device.localIP)")
                      | IP
                    td {{device.localIP}}
                  tr
                    th
                      i.fas.fa-microchip(v-tooltip.top="lang['CPU usage']")
                      | {{lang['CPU usage']}}
                    td {{device.cpuLoad | cpuFormat}}
                  tr
                    th
                      i.fas.fa-memory(v-tooltip.top="lang['Free RAM']")
                      | RAM
                    td {{device.freeMem | memFormat}}
                  tr
                    th
                      i.fas.fa-hdd(v-tooltip.top="lang['Disk space used']")
                      | SDD
                    td {{device.diskUsagePercent}} %
                  tr
                    th
                      i.fas.fa-thermometer(v-tooltip.top="lang['CPU Temp']")
                      | Temp
                    td {{device.cpuTemp | tempFormat}}
              h3 {{lang['Peripheries']}}
              table.table.table-condensed.table-hover.device
                tbody
                  tr
                    th
                      i.fas.fa-print(v-tooltip.top="lang['Pritner status']")
                      | {{lang['Pritner status']}}
                    td {{printerStatusText}}
                  tr
                    th
                      i.fas.fa-plug(v-tooltip.top="lang['Printer power']")
                      | {{lang['Printer power']}}
                    td {{printerPower}}
                  tr
                    th
                      i.fas.fa-toilet-paper(v-tooltip.top="lang['Printer paper']")
                      | {{lang['Printer paper']}}
                    td {{paperStatusText}}
                  tr
                    th
                      i.fas.fa-hashtag(v-tooltip.top="lang['Printer number']")
                      | {{lang['Printer number']}}
                    td {{payments | printerFromPayments}}
                  tr
                    th
                      i.fas.fa-slash(v-tooltip.top="lang['Printer type']")
                      | {{lang['Printer type']}}
                    td {{hardware | printerType}}
                  tr
                    th
                      i.fas.fa-cogs(v-tooltip.top="lang['Configuration']")
                      | {{lang['Configuration']}}
                    td(v-if="device.printer")
                      button.btn.btn-primary.btn-xs.printerConfig.collapse.in(type="button" @click="toggleCollapse('printerConfig')") {{lang['Show']}}
                      button.btn.btn-primary.btn-xs.printerConfig.collapse(type="button" @click="toggleCollapse('printerConfig')") {{lang['Hide']}}
                    td(v-else)
                      | n/a
                  tr.moredata
                    td(colspan="2")
                      .printerConfig.collapse
                        pre {{ JSON.stringify(device.printer, null, 2) }}
                  tr.next
                    th
                      i.fas.fa-credit-card(v-tooltip.top="lang['Payment Term. State']")
                      | {{lang['Payment Term. State']}}
                    td {{terminalStatusText}}
                  tr
                    th
                      i.fas.fa-hashtag
                      | TID
                    td {{payments | terminalFromPayments}}
                  tr
                    th
                      i.fas.fa-cogs(v-tooltip.top="lang['Configuration']")
                      | {{lang['Configuration']}}
                    td(v-if="device.terminal")
                      button.btn.btn-primary.btn-xs.terminalConfig.collapse.in(type="button" @click="toggleCollapse('terminalConfig')") {{lang['Show']}}
                      button.btn.btn-primary.btn-xs.terminalConfig.collapse(type="button" @click="toggleCollapse('terminalConfig')") {{lang['Hide']}}
                    td(v-else)
                      | n/a
                  tr.moredata
                    td(colspan="2")
                      .terminalConfig.collapse
                        pre {{ JSON.stringify(device.terminal, null, 2) }}
              h3 Hardware
              table.table.table-condensed.table-hover.device
                tbody
                  tr
                    th
                      i.fas.fa-hashtag(v-tooltip.top="lang['Serial']")
                      | {{lang['Serial']}}
                    td {{device.serial}}
                  tr
                    th
                      i.fas.fa-hashtag(v-tooltip.top="lang['Model']")
                      | {{lang['Model']}}
                    td {{device.productModel || 'n/a'}}
                  tr
                    th
                      i.fas.fa-tv(v-tooltip.top="lang['Screens']")
                      | {{lang['Screens']}}
                    td {{screens | screensFormat}}
                  tr
                    th
                      i.fas.fa-chess-board(v-tooltip.top="lang['Mainboard']")
                      | {{lang['Mainboard']}}
                    td {{hardware | hardwareMotherboardFormat}}
                  tr
                    th
                      i.fas.fa-microchip(v-tooltip.top="'CPU'")
                      | CPU
                    td {{hardware | hardwareCpuFormat}}
                  tr
                    th
                      i.fas.fa-link(v-tooltip.top="'MAC'")
                      | MAC
                    td {{device.localMAC}}
                  tr
                    th
                      i.fab.fa-usb(v-tooltip.top="lang['USB devices']")
                      | {{lang['USB devices']}}
                    td
                      button.btn.btn-primary.btn-xs.usbDevices.collapse.in(type="button" @click="toggleCollapse('usbDevices')") {{lang['Show']}}
                      button.btn.btn-primary.btn-xs.usbDevices.collapse(type="button" @click="toggleCollapse('usbDevices')") {{lang['Hide']}}
                  tr.moredata
                    td(colspan="2")
                      .usbDevices.collapse
                        pre(style="white-space: pre-wrap;") {{usbDevicesText}}
              h3(v-if="software") Software
              table.table.table-condensed.table-hover.device(v-if="software")
                tbody
                  tr(v-if="software.localConfig")
                    th
                      i.fas.fa-hashtag(v-tooltip.top="lang['Cookbook version']")
                      | {{lang['Cookbook version']}}
                    td {{software | cookbookVersion}}
                  tr(v-if="software.localConfig && software.localConfig.kiosk")
                    th
                      i.fas.fa-cogs(v-tooltip.top="lang['Configuration']")
                      | {{lang['Configuration']}}
                    td
                      button.btn.btn-primary.btn-xs.software.collapse.in(type="button" @click="toggleCollapse('software')") {{lang['Show']}}
                      button.btn.btn-primary.btn-xs.software.collapse(type="button" @click="toggleCollapse('software')") {{lang['Hide']}}
                  tr(v-if="software.localConfig && software.localConfig.kiosk").moredata
                    td(colspan="2")
                      .software.collapse
                        pre {{ JSON.stringify(software.localConfig.kiosk, null, 2) }}
            .center-panel
              .preview(:style="{'background-image': 'url(' + screenShot + ')'}")
              .buttons
                .left
                  .deviceshot-time {{device.screenshot | screenShotDateTime}}
                  button.btn.btn-default.btn-sm.text-primary(type="button" @click="$emit('refreshSs', device.id)" v-tooltip.top="lang['Refresh screenshot']")
                    i.fas.fa-camera.fa-lg
                  span(v-if="$store.getters.hasRole(['admin', 'manager'])")
                    button.btn.btn-default.btn-sm.text-info(type="button" @click="$emit('restartView', device.id)" v-tooltip.top="lang['Restart Chrome']")
                      i.fab.fa-chrome.fa-lg
                    button.btn.btn-default.btn-sm.text-warning(type="button" @click="$emit('restartApp', device.id)" v-tooltip.top="lang['Restart App']")
                      i.fa.fa-undo.fa-lg
                    button.btn.btn-default.btn-sm.text-danger(type="button" @click="$emit('restartDevice', device.id)" v-tooltip.top="lang['Restart Kiosk']")
                      i.fa.fa-power-off.fa-lg
                    button.btn.btn-default.btn-sm.text-success(v-if="device.enabled && $store.getters.hasRole(['admin', 'manager']) && isEnableVersionValid(device.version)" @click="$emit('enableDevice', {'id': device.id, 'enable': false})" type="button" v-tooltip.top="lang['Deactivate']")
                      i.fa.fa-tablet-alt
                    button.btn.btn-default.btn-sm.text-danger(v-if="!device.enabled && $store.getters.hasRole(['admin', 'manager']) && isEnableVersionValid(device.version)" @click="$emit('enableDevice', {'id': device.id, 'enable': true})" type="button" v-tooltip.top="lang['Activate']")
                      i.fa.fa-tablet-alt
                .right
                  .hb-time {{device.hbtime | formatDateTime}}
                  button.btn.btn-sm.heartbeat.disabled(type="button" :class="device.failure || device.kiosk_status | eqStatusBtn" v-tooltip.top="lang['Hardware status'] + kioskStatus")
                    i.fa.fa-inverse.fa-lg(:class="device.failure || device.kiosk_status | eqStatusIcon")
                  button.btn.btn-sm.heartbeat.disabled(type="button" :class="hbStatus" v-tooltip.top="lang['Pulse']")
                    i.fa.fa-heartbeat.fa-inverse.fa-lg(:class="hbStatusPulse")
            .right-panel
              h3 {{lang['Last 20 purchases']}}
                small
                  router-link(:to="{name: 'payments', params: {device: device, originType: $route.params.type}}") &nbsp;{{lang['more']}}...
              .events
                transition(name='fade')
                  .loaderContainerLocal(v-if="showLoaderEvents")
                    .loader-ring
                      .loader-ring-light
                  table.table.table-condensed.table-hover(v-else)
                    thead
                      tr
                        th {{lang['Date']}}
                        th {{lang['Status']}}
                        th {{lang['MicrosId']}}
                        th {{lang['Amount']}}
                    tbody
                      tr(v-for="event in payments" :key="event.id" :class="event.status | paymentClass" @dblclick="showPayment = true; payment = event; removeEsc();")
                        td {{event.createdAt | formatDateTime}}
                        td {{event.status | statusDict}}
                          span(v-if="event.reversalReason") &nbsp;- {{ event.reversalReason }}
                        td {{event.microsId}}
                        td {{event.total | moneyFormat}}
              h3 {{lang['Last 20 errors']}}
                small
                  router-link(:to="{name: 'errors', params: {device: device, originType: $route.params.type}}") &nbsp;{{lang['more']}}...
              .errors
                transition(name='fade')
                  .loaderContainerLocal(v-if="showLoaderErrors")
                    .loader-ring
                      .loader-ring-light
                  table.table.table-condensed.table-hover(v-else)
                    thead
                      tr
                        th {{lang['Date']}}
                        th {{lang['Code']}}
                        th {{lang['Place']}}
                        th {{lang['Object']}}
                        th {{lang['Error']}}
                        th {{lang['Email']}}
                    tbody
                      tr(v-for="error in matrixerrors" :key="error.id" :class="error.matrix.level | matrixLevelClass" @dblclick="showError = true; errorSel = error; matrixSel = error.matrix; removeEsc();")
                        td {{error.createdAt | formatDateTime}}
                        td {{error.matrix.code}}
                        td {{error.matrix.area}}
                        td {{error.matrix.object}}
                        td {{error.matrix.error}}
                        td
                          i.fa(:class="error.sentR | sentIcon" aria-hidden="true")
              h3 {{lang['Last 20 status changes']}}
              .statuses
                transition(name='fade')
                  .loaderContainerLocal(v-if="showLoaderStatuses")
                    .loader-ring
                      .loader-ring-light
                  table.table.table-condensed.table-hover(v-else)
                    thead
                      tr
                        th {{lang['Date']}}
                        th {{lang['Summary']}}
                        th {{lang['Operation']}}
                        th {{lang['Failure']}}
                        th {{lang['Power']}}
                    tbody
                      tr(v-for="status in statuses" :key="status.id" @dblclick="showStatus = true; statusSel = status; removeEsc();")
                        td {{status.createdAt | formatDateTime}}
                        td(:class="status.summary | statusSummaryClass") {{status.summary}}
                        td(:class="status.operation | statusOperationClass") {{status.operation}}
                        td(:class="status.failureState | statusFailureStateClass") {{status.failureState}}
                        td(:class="status.power | statusPowerClass") {{status.power}}
</template>

<script>
import Vue from 'vue'
import errorModal from '@/components/errors/Error'
import paymentModal from '@/components/payments/Payment'
import statusModal from '@/components/statusChanges/StatusChange'

export default {
  name: 'device-detail',
  props: ['lang', 'deviceIndex'],
  data () {
    return {
      showConfig3eContainer: true,
      imeValue: '',
      showError: false,
      showPayment: false,
      showStatus: false,
      errorSel: '',
      matrixSel: '',
      payment: '',
      hbStatus: '',
      matrixerrors: [],
      payments: [],
      statuses: [],
      showLoaderEvents: true,
      showLoaderErrors: true,
      showLoaderStatuses: true
    }
  },
  components: {
    'error-modal': errorModal,
    'payment-modal': paymentModal,
    'status-modal': statusModal
  },
  methods: {
    toggleCollapse (id) {
      // find element with id and toggle .in class
      const elements = document.getElementsByClassName(id)
      for (let i = 0; i < elements.length; i++) {
        elements[i].classList.toggle('in')
      }
    },
    copyToClipboard (text) {
      const el = document.createElement('textarea')
      el.value = text
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      this.$notify(this.lang['Copied to clipboard'], 'success')
    },
    isEnableVersionValid (version) {
      return true
      // let result = false
      // try {
      //   result = semver.satisfies(version, `>=${this.$store.getters.enableMinVersion}`)
      // } catch (error) {
      //   // console.error('semver version error', error)
      // }
      // return result
    },
    getMatrixErrors () {
      this.$http.get('networkerrormatrixerror',
        {
          params:
          {
            where: {device: this.device.id},
            limit: 20,
            sort: 'createdAt DESC'
          }
        })
        .then(response => {
          return response.json()
        })
        .then(data => {
          this.showLoaderErrors = false
          const resultArray = []
          for (let key in data) {
            resultArray.push(data[key])
          }
          this.matrixerrors = resultArray
        })
    },
    getPayments () {
      this.$http.get('devicepaymentlog',
        {
          params:
          {
            where: {device: this.device.id},
            limit: 20,
            sort: 'createdAt DESC'
          }
        })
        .then(response => {
          return response.json()
        })
        .then(data => {
          this.showLoaderEvents = false
          const resultArray = []
          for (let key in data) {
            resultArray.push(data[key])
          }
          this.payments = resultArray
        })
    },
    getStatuses () {
      this.$http.get('statuschange',
        {
          params:
          {
            where: {device: this.device.id},
            limit: 20,
            sort: 'createdAt DESC'
          }
        })
        .then(response => {
          return response.json()
        })
        .then(data => {
          this.showLoaderStatuses = false
          const resultArray = []
          for (let key in data) {
            resultArray.push(data[key])
          }
          this.statuses = resultArray
        })
    },
    closeError () {
      this.showError = false
      window.addEventListener('keyup', this.escapeModal, false)
    },
    closePayment () {
      this.showPayment = false
      window.addEventListener('keyup', this.escapeModal, false)
    },
    closeStatus () {
      this.showStatus = false
      window.addEventListener('keyup', this.escapeModal, false)
    },
    removeEsc () {
      window.removeEventListener('keyup', this.escapeModal, false)
    },
    escapeModal (e) {
      if (e.key === 'Escape') {
        this.$emit('close')
      }
    },
    edit (desc, value, ref) {
      let res = prompt('Edytuj ' + desc, value)
      if (res && res !== value) {
        var obj = {}
        obj[ref] = res
        this.$http.patch('device/' + this.device.id, obj)
          .then(response => {
            return response.json()
          })
          .then(data => {
            if (typeof data[ref] !== 'undefined') {
              this.device[ref] = data[ref]
            }
          })
      }
    },
    hbStatusUpdate () {
      var self = this
      self.$data.ticker = new Date().getTime()
      if (self.device.hbtime && new Date().getTime() < new Date(self.device.hbtime + self.$store.state.config.heartbeatInterval * 2 * 1000).getTime()) {
        self.$data.hbStatus = 'btn-success'
      } else {
        self.$data.hbStatus = 'btn-danger'
      }
    },
    parseErrors (type) {
      let errorText = ''
      if (this.device.failure && this.device.failure.errors) {
        const typeError = this.device.failure.errors.filter(x => x.error_type.toUpperCase() === type.toUpperCase())
        if (typeError) {
          if (typeError.length) {
            typeError.forEach(error => {
              // Sanitize the status_description to prevent XSS
              const sanitized = error.status_description ? String(error.status_description).replace(/[<>"'&]/g, (match) => {
                const escapeMap = {
                  '<': '&lt;',
                  '>': '&gt;',
                  '"': '&quot;',
                  "'": '&#x27;',
                  '&': '&amp;'
                }
                return escapeMap[match]
              }) : ''
              errorText += `${sanitized}<br>`
            })
          } else {
            // Sanitize single error description
            const sanitized = typeError.status_description ? String(typeError.status_description).replace(/[<>"'&]/g, (match) => {
              const escapeMap = {
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;',
                "'": '&#x27;',
                '&': '&amp;'
              }
              return escapeMap[match]
            }) : ''
            errorText = sanitized
          }
        }
      }
      return errorText
    },
    parseErrorsPlainText (type) {
      // Return plain text version without HTML tags for safe interpolation
      let errorText = ''
      if (this.device.failure && this.device.failure.errors) {
        const typeError = this.device.failure.errors.filter(x => x.error_type.toUpperCase() === type.toUpperCase())
        if (typeError) {
          if (typeError.length) {
            const errors = []
            typeError.forEach(error => {
              // Sanitize the status_description to prevent XSS
              const sanitized = error.status_description ? String(error.status_description).replace(/[<>"'&]/g, (match) => {
                const escapeMap = {
                  '<': '&lt;',
                  '>': '&gt;',
                  '"': '&quot;',
                  "'": '&#x27;',
                  '&': '&amp;'
                }
                return escapeMap[match]
              }) : ''
              errors.push(sanitized)
            })
            errorText = errors.join(', ')
          } else {
            // Sanitize single error description
            const sanitized = typeError.status_description ? String(typeError.status_description).replace(/[<>"'&]/g, (match) => {
              const escapeMap = {
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;',
                "'": '&#x27;',
                '&': '&amp;'
              }
              return escapeMap[match]
            }) : ''
            errorText = sanitized
          }
        }
      }
      return errorText
    },
    disableScroll () {
      document.body.style.overflow = 'hidden'
    },
    enableScroll () {
      document.body.style.overflow = ''
    }
  },
  computed: {
    device () {
      return this.$store.getters.filteredDevices[this.deviceIndex]
    },
    wave2Server () {
      return (this.device.kfc_configuration && this.device.kfc_configuration.length > 0 && this.device.kfc_configuration[0].wave2Server) ? this.device.kfc_configuration[0].wave2Server : ''
    },
    hbStatusPulse () {
      if (this.hbStatus === 'btn-success') {
        return 'animated infinite pulse'
      }
    },
    screenShot () {
      let sshotPath = '/static/no-sshot.png'
      if (this.device.screenshot[0] && this.device.screenshot[0].filepath.length > 0) {
        sshotPath = this.device.screenshot[0].filepath
      }
      return sshotPath
    },
    printerStatus () {
      return (this.parseErrors('printer_problem')) ? this.parseErrors('printer_problem') : 'OK'
    },
    printerStatusText () {
      // Return plain text version for safe interpolation
      return (this.parseErrorsPlainText('printer_problem')) ? this.parseErrorsPlainText('printer_problem') : 'OK'
    },
    printerPower () {
      return (this.parseErrors('printer_no_power')) ? this.parseErrors('printer_no_power') : 'OK'
    },
    paperStatus () {
      let state = (this.parseErrors('no_paper') || this.parseErrors('printer_low_paper')) ? this.parseErrors('no_paper') + this.parseErrors('printer_low_paper') : 'OK'
      return state
    },
    paperStatusText () {
      // Return plain text version for safe interpolation
      let state = (this.parseErrorsPlainText('no_paper') || this.parseErrorsPlainText('printer_low_paper')) ? this.parseErrorsPlainText('no_paper') + ' ' + this.parseErrorsPlainText('printer_low_paper') : 'OK'
      return state.trim()
    },
    terminalStatus () {
      return (this.parseErrors('terminal_problem')) ? this.parseErrors('terminal_problem') : 'OK'
    },
    terminalStatusText () {
      // Return plain text version for safe interpolation
      return (this.parseErrorsPlainText('terminal_problem')) ? this.parseErrorsPlainText('terminal_problem') : 'OK'
    },
    usbDevicesText () {
      // Return sanitized plain text version of USB devices
      if (this.hardware && this.hardware.usbDevices) {
        const sanitizeString = (str) => {
          return str ? String(str).replace(/[<>"'&]/g, (match) => {
            const escapeMap = {
              '<': '&lt;',
              '>': '&gt;',
              '"': '&quot;',
              "'": '&#x27;',
              '&': '&amp;'
            }
            return escapeMap[match]
          }) : ''
        }
        if (typeof this.hardware.usbDevices[0] === 'object') {
          return this.hardware.usbDevices.filter((line) => {
            return (!line.S || !Array.isArray(line.S) || !line.S[0].startsWith('Manufacturer=Linux'))
          }).map((obj) => {
            return Object.values(obj).flat()
          }).map((obj) => {
            return obj.map(item => sanitizeString(item)).join('\n')
          }).join('\n\n')
        } else {
          let show = false
          let result = []
          this.hardware.usbDevices.forEach((line) => {
            const sanitizedLine = sanitizeString(line)
            if (line.startsWith('Manufacturer=Linux')) show = false
            if (line.startsWith('Manufacturer') && !line.startsWith('Manufacturer=Linux')) {
              show = true
              result.push(`*** ${sanitizedLine} ***`)
            }
            if (show && !line.startsWith('Manufacturer')) result.push(sanitizedLine)
          })
          return result.join('\n')
        }
      } else {
        return 'n/a'
      }
    },
    kioskStatus () {
      return Vue.filter('hwStatus')(this.device, this.lang.lang)
    },
    hardware () {
      return this.device.hardware
    },
    software () {
      return this.device.software
    },
    screens () {
      return this.device.screens
    }
  },
  created: function () {
    this.disableScroll()
    this.$store.commit('SET_OPENDETAILID', undefined)
    let self = this
    self.autoRaportPrintCheck = self.autoRaportPrint
    self.hbStatusUpdate()
    if (!FileReader) {
      self.showConfig3eContainer = false
    }
    self.getMatrixErrors()
    self.getPayments()
    self.getStatuses()
    window.addEventListener('keyup', this.escapeModal, false)
  },
  beforeDestroy () {
    this.enableScroll()
    this.removeEsc()
    this.matrixerrors = []
    this.payments = []
  }
}
</script>
<style lang="sass">
  @use "sass:math"
  @import "~sass/_variables.scss"

  $preview-width: 286px + math.div($gutter, 2)
  $preview-height: 518px

  .modall-mask
    position: fixed
    z-index: 9999
    top: 0px
    width: 100%
    background: $gray-darker
    left: 0
    padding: 20px
    min-height: 120%
    height: 120%
    overflow: scroll

  pre
    background: none
    color: $text-color
    padding: 10px
    border: none

  .device-details
    position: relative
    padding-bottom: 20%

    .close
      position: relative
      left: 0px
      top: 0px

    h2
      margin-top: 0
      margin-bottom: 0
      font-size: 30px

    h3
      margin-top: 0
      margin-bottom: 0
      display: inline-block

    .fas, .fab
      min-width: 24px
      opacity: .6

      &.clickable
        cursor: pointer
        opacity: 1

    .panels
      display: flex
      max-height: 100%

      .left-panel
        overflow: hidden
        width: calc( 50% - math.div(( $preview-width - math.div($gutter, 2) ), 2) )

        .config3eFile
          width: 0
          height: 0
          display: none

        table.device
          width: 100%
          margin-bottom: math.div($gutter, 8)

          .next
            border-top-style: solid
            border-top-width: 4px

          tr.moredata
            &:hover
              background-color: unset
            td
              padding: 0
              border: none
          th
            width: 32%
            white-space: nowrap

          td
            white-space: nowrap

            .usb-device-start:not(:first-child)
              display: inline-block
              margin-top: 1rem

        .w2-close
          position: absolute
          bottom: $gutter
          right: $gutter

      .center-panel
        width: $preview-width
        margin: 0 math.div($gutter, 2)
        margin-top: $gutter

        .preview
          position: relative
          width: 100%
          height: $preview-height
          background-repeat: no-repeat
          background-size: contain
          background-position: 0% 100%
          background-color: $gray-dark
          border: solid .2px $gray

        .buttons
          position: relative

          .btn
            clear: right
            height: 46px

          .left
            position: relative
            width: 210px
            z-index: 1

            .deviceshot-time
              height: 21px
              position: relative

          .right
            position: absolute
            right: 0
            top: 0
            text-align: right

            .hb-time
              height: 21px
              position: relative

      .right-panel
        height: 100%
        float: right
        width: calc( 50% - math.div(( $preview-width - math.div($gutter, 2) ), 2) )
        position: relative

        .loaderContainer
          background: none

          .loader-ring
            margin: -25px 0 0 -25px

            .loader-ring-light
              width: 50px
              height: 50px

        h3
          margin-top: 8px

        .errors, .events, .statuses
          position: relative
          overflow-y: scroll
          height: 300px

          td
            cursor: pointer

          .level1
            background-color: $brand-danger

          .level2
            background-color: $brand-warning

          .level3
            background-color: $brand-info

          .level-
            background-color: none
</style>



// WEBPACK FOOTER //
// src/components/device/DeviceDetail.vue